// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__2plzt","btn":"Pagination_btn__AV51c","text":"Pagination_text__27W4T"};